import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Typography } from "@material-ui/core";
import { ESTADO_SOLICITUD_INTEGRACION } from "../../../data/constants";
import { cambiarEstadoSolicitudDiscapacidad, getSolicitudesContadoresGestionIntegracion } from "../../../../../actions/discapacidad/discapacidadActions";
import { AlertFinalizadoStepper } from "../../../../stepper/AlertFinalizadoStepper";
import { TIPO_NOTA_SOLICITUD_INTEGRACION } from "../../../../../utils/constants";
import { ModalNotasIntegracion } from "./ModalNotasIntegracion";

export const AdministrarIntegracionMenu = (props) => {
  const dispatch = useDispatch();

  const [openModalNotas, setOpenModalNotas] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [idEstadoNota, setIdEstadoNota] = useState(null);

  const { solicitudSeleccionada = {}, estadoSolicitudes } = useSelector(
    (state) => state.discapacidad
  );

  const onClickCambiarEstadoSolicitud = (idEstadoSolicitud) => {
    const data = {
      idSolicitud: solicitudSeleccionada.idSolicitud,
      idEstadoSolicitud
    };

    if(idEstadoSolicitud === ESTADO_SOLICITUD_INTEGRACION.RECHAZADA ||
      idEstadoSolicitud === ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA) {
        setIdEstadoNota(idEstadoSolicitud);
        setOpenModalNotas(true);
    } else {
      dispatch(cambiarEstadoSolicitudDiscapacidad(data, false, true, props.closeModalAuditar, setOpenAlert));
    }
  };

  const onClickCloseAlertModal = () => {
    setOpenAlert(false);
    props.closeModalAuditar(false);
    dispatch(
      getSolicitudesContadoresGestionIntegracion(null, null, null, null, null, parseInt(estadoSolicitudes))
    );
  }

  return (
    <React.Fragment>
      <Typography
        variant="h6"
        style={{
          textAlign: "center",
          margin: "1.5rem 0",
        }}
      >
        Enviar a:
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >
        <Button
          style={{ margin: "0.5rem", marginTop: -15, flexBasis: "30%" }}
          variant="contained"
          color="secondary"
          onClick={() =>
            onClickCambiarEstadoSolicitud(
              solicitudSeleccionada.idEstadoSolicitud ===
                ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA
                ? ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION
                : ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA
            )
          }
        >
          {solicitudSeleccionada.idEstadoSolicitud ===
            ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA
            ?
              'PENDIENTE AUTORIZACION'
            : 
              solicitudSeleccionada.idEstadoSolicitud ===
                ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION
                ? 'AUDITORIA ADMINISTRATIVA'
                : 'ESTADO NO VALIDO'
          }
        </Button>
      </div>
      <Typography
        variant="h6"
        style={{
          textAlign: "center",
          margin: "1.5rem 0",
          marginTop: 50
        }}
      >
        Acciones sobre la Solicitud:
      </Typography>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >        
      {openModalNotas && (
            <ModalNotasIntegracion
              open={openModalNotas}
              close={() => {
                setOpenModalNotas(false);
              }}
              desdeIngresoSolicitud={false}
              idSolicitud={solicitudSeleccionada.idSolicitud}
              disabled={false}
              titulo={`Agregar Nota ${idEstadoNota === ESTADO_SOLICITUD_INTEGRACION.RECHAZADA ? 'Rechazo' : ''}`}
              idTipoNota={idEstadoNota === ESTADO_SOLICITUD_INTEGRACION.RECHAZADA
                ? TIPO_NOTA_SOLICITUD_INTEGRACION.RECHAZO
                : TIPO_NOTA_SOLICITUD_INTEGRACION.DEVOLUCION}
              nota={null}
              idEstadoSolicitud={idEstadoNota}
              closeModalAuditar={props.closeModalAuditar}
            />
          )}
        <Button
          style={{
            margin: "0.5rem",
            flexBasis: "30%",
            backgroundColor: "red",
            color: "white",
          }}
          variant="contained"
          onClick={() =>
            onClickCambiarEstadoSolicitud(
              ESTADO_SOLICITUD_INTEGRACION.RECHAZADA
            )
          }
        >
          Rechazar
        </Button>
        {solicitudSeleccionada.idEstadoSolicitud ===
          ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickCambiarEstadoSolicitud(
                ESTADO_SOLICITUD_INTEGRACION.AUTORIZADA
              )
            }
          >
            Aprobar
          </Button>
        }
        {openAlert && (
          <AlertFinalizadoStepper
            open={openAlert}
            pregunta={'Información importante'}
            dialogText={'La Solicitud se Autorizo Correctamente pero el email al prestador no pudo ser enviado porque no esta cargado'}
            buttonSubmit={"Aceptar"}
            handleSend={onClickCloseAlertModal}
          />
        )}        
      </div>
    </React.Fragment>
  );
};
